import produce, {Draft} from "immer";
import {LoadingStatus} from "../../status";
import {GraphsActions} from "./actionCreators";
import {GraphsAT} from "./actionTypes";
import {GraphsState} from "./stateTypes";

const initialGraphsState: GraphsState = {
    graphsData: null,
    liveData: null,
    isLivePage: false,
    isHourlyPage:false,
    f500Nodes: null,
    status: LoadingStatus.NEVER,
    status_operation: LoadingStatus.NEVER,
};

export const graphsReducer = produce((draft: Draft<GraphsState>, action: GraphsActions) => {
    Label:if (action.type === GraphsAT.SET_GRAPHS_DATA) {
        draft.graphsData = action.payload;
        draft.status = LoadingStatus.SUCCESS;
    } else if (action.type === GraphsAT.SET_F500_NODES) {
        draft.f500Nodes = action.payload;
        draft.status = LoadingStatus.SUCCESS;
    } else if (action.type === GraphsAT.UPDATE_OLD_GRAPHS_DATA) {// Determine which dataset we are actually updating
        const isLive = draft.isLivePage;
        const currentData = isLive ? draft.liveData : draft.graphsData;
        const nextData = action.payload;

        if (!currentData) {
                if (isLive) {
                    draft.liveData = nextData;
                } else {
                    draft.graphsData = nextData;
                }
                break Label;
        }

        if (!isLive) {
            draft.graphsData = nextData;
            break Label;
        }

        // Merge logic
        const existingGraphNames = Object.keys(currentData.graphs);

        for (let graphName of existingGraphNames) {
            const currentGraph = currentData.graphs[graphName];
            const newGraph = nextData.graphs[graphName];

            if (!newGraph) continue;

            for (let i = 0; i < currentGraph.series.length; i++) {
                const currentSeries = currentGraph.series[i];

               const matchingNextSeries = newGraph.series.find(
                    (s: any) => s.sensor.toString() === currentSeries.sensor.toString()
                    );

                if (!matchingNextSeries) continue;

                const lastTimestamp = currentSeries.data.length > 0
                    ? currentSeries.data[currentSeries.data.length - 1][0]
                    : 0;

                const uniqueNewPoints = matchingNextSeries.data.filter((point: any) => point[0] > lastTimestamp);

                currentSeries.data.push(...uniqueNewPoints);
            }
        }

        // Ensure the UI knows a success happened without a full spinner refresh
        draft.status = LoadingStatus.SUCCESS;
    } else if (action.type === GraphsAT.SET_LOADING_STATUS_GRAPHS) {
        draft.status = action.payload;
    } else if (action.type === GraphsAT.CLEAR_LIVE_DATA) {
        draft.liveData = null;
    } else if (action.type === GraphsAT.SET_GRAPHS_STATUS_OPERATION) {
        draft.status_operation = action.payload;
    } else if (action.type === GraphsAT.CLEAR_GRAPHS_STATE) {
        draft.graphsData = null;
    } else if (action.type === GraphsAT.SET_LIVE_GRAPHS_DATA_TAB) {
        draft.isLivePage = action.payload;
    } else if (action.type === GraphsAT.SET_HOURLY_GRAPHS_DATA_TAB) {
        draft.isHourlyPage = action.payload;
    } else {
    }
}, initialGraphsState);
